import $ from 'jquery';
import { Component } from '@mycolorway/tao';
import { closest } from 'next/javascripts/modules/dom';
import { setOuterHTML } from 'next/javascripts/modules/utils';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import updateTodoMixin from 'next/javascripts/mixins/update-todo-mixin';
import resourceSubject from 'next/javascripts/reactivity/resource-subject';
import 'next/stylesheets/components/todo-item-plus';

Component('tr-todo-item-plus', {
  mixins: [eventListenerMixin, updateTodoMixin],

  properties: {
    guid: String,
    todoDetailUrl: String,
    todoItemUrl: String,
    completionStatusUrl: String,
    editing: {
      type: Boolean,
      default: false,
    },
    assignToOther: {
      type: Boolean,
      default: false,
    },
  },

  ready() {
    this.listenTo(this, {
      'tr-selector-field-list:opened': this.beginEditing.bind(this),
      'tr-selector-field-list:closed': () => { this.editing = false; },
      'tr-date-picker-field-list:opened': this.beginEditing.bind(this),
      'tr-date-picker-field-list:closed': () => { this.editing = false; },
      'tr-menu:opened': this.beginEditing.bind(this),
      'tr-menu:closed': () => { this.editing = false; },
      'tr-checkbox-field:change': this.handleCheckboxChange.bind(this),
      click: this.handleClick.bind(this),
    });

    $(this)
      .on('ajax:success', '.todo-actions .run', this.handleRunTodo.bind(this))
      .on('ajax:success', '.todo-actions .pause', this.handlePauseTodo.bind(this))
      .on(
        'ajax:beforeSend',
        '.todo-actions .edit, .assignee-selector, .tr-todo-date-field, .tr-todo-priority-menu',
        this.beginEditing.bind(this),
      );

    this.subscription = resourceSubject('todo').subscribe({
      next: (event, todo) => {
        if (todo.guid !== this.dataset.guid || todo.isTouched) return;
        if (event === 'update:pusher' && this.todoItemUrl) {
          $.getScript(this.todoItemUrl);
        }
      },
    });
  },

  async replaceTodoItem(newTodoItem) {
    const subTodosContainer = this.querySelector('.sub-todos');

    if (subTodosContainer) {
      $(newTodoItem).append(subTodosContainer);
      $(this).replaceWith(newTodoItem);
    } else if (newTodoItem.assignToOther) {
      await this.removeSelfAndParent();
    } else {
      $(this).replaceWith(newTodoItem);
    }
  },

  insertInlineForm($form) {
    $form.one('tao:disconnected', () => { this.editing = false; });
    $form.insertBefore(this.querySelector('.todo-title-container'));
  },

  beginEditing(event) {
    const item = closest(event.target, 'tr-todo-item-plus');
    if (item) item.editing = true;
  },

  handleRunTodo(event) {
    event.stopPropagation();
    this.run();
    this.namespacedTrigger('running', { bubbles: true });
  },

  handlePauseTodo(event) {
    event.stopPropagation();
    this.pause();
    this.namespacedTrigger('pause', { bubbles: true });
  },

  run() {
    this.classList.add('running');
    this.assignToCurrentMember();
  },

  pause() {
    this.classList.remove('running');
  },

  assignToCurrentMember() {
    const { me: currentMember } = window.tower;
    const assigneeSelector = this.querySelector('tr-todo-assignee-select-field');

    if (assigneeSelector) {
      assigneeSelector.setValue(currentMember.guid);
    } else {
      const assignee = this.querySelector('.assignee-selector .selected-text');
      const icon = assignee.querySelector('.icon');
      const avatar = assignee.querySelector('.avatar');

      if (icon) {
        setOuterHTML(icon, `
          <img src="${currentMember.avatar}" class="avatar" alt="${currentMember.nickname}" />
        `);
      } else if (avatar) {
        avatar.src = currentMember.avatar;
        avatar.alt = currentMember.nickname;
      }

      assignee.querySelector('.text').textContent = currentMember.nickname;
    }

    // eslint-disable-next-line no-param-reassign
    this.dataset.assigneeGuid = currentMember.guid;
  },

  handleClick(e) {
    const restNode = closest(e.target, '.title-content .todo-rest', this);
    if (restNode
      && !this.namespacedTrigger('openpage',
        { bubbles: true, detail: { url: this.todoDetailUrl } })) {
      e.preventDefault();
      e.stopPropagation();
    }
  },

  handleCheckboxChange(e) {
    e.stopPropagation();

    $.ajax({
      url: this.completionStatusUrl,
      dataType: 'script',
      type: 'post',
    });
  },

  async removeSelfAndParent() {
    const parent = $(this).parents('tr-todo-item-plus').get(0);
    const shouldRemoveParent = parent && parent.assignToOther && [
      ...parent.querySelectorAll('tr-todo-item-plus'),
    ].filter(item => item !== this).length === 0;

    if (shouldRemoveParent) {
      await parent.remove();
    } else {
      await this.remove();
    }
  },

  remove() {
    return new Promise((resolve) => {
      $(this).fadeTo(200, 0);
      $(this).slideUp(200, () => {
        $(this).remove();
        resolve();
      });
    });
  },

  disconnected() {
    this.stopListening();

    if (this.subscription) {
      this.subscription.unsubscribe();
      this.subscription = null;
    }
  },
});
